export const MIN_AGE_YEARS = 18;

const FULL_DATE_LENGTH = 10; // DD/MM/AAAA
const MIN_YEAR = 1900;

function parseDdMmYyyy(value: string): { day: number; month: number; year: number } | null {
  if (value.length !== FULL_DATE_LENGTH) return null;
  const [dayStr, monthStr, yearStr] = value.split('/');
  if (!dayStr || !monthStr || !yearStr) return null;
  const day = Number(dayStr);
  const month = Number(monthStr);
  const year = Number(yearStr);
  if (!Number.isInteger(day) || !Number.isInteger(month) || !Number.isInteger(year)) return null;
  return { day, month, year };
}

function calcCompleteAge(year: number, month: number, day: number, now: Date): number {
  let age = now.getUTCFullYear() - year;
  const todayMonth = now.getUTCMonth() + 1;
  const todayDay = now.getUTCDate();
  if (todayMonth < month || (todayMonth === month && todayDay < day)) {
    age -= 1;
  }
  return age;
}

export function isValidBirthDate(value: string): boolean {
  const parsed = parseDdMmYyyy(value);
  if (!parsed) return false;
  const { day, month, year } = parsed;
  if (year < MIN_YEAR) return false;
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;

  const candidate = new Date(Date.UTC(year, month - 1, day));
  if (candidate.getUTCFullYear() !== year || candidate.getUTCMonth() !== month - 1 || candidate.getUTCDate() !== day) {
    return false;
  }

  const now = new Date();
  if (candidate.getTime() > now.getTime()) return false;

  const age = calcCompleteAge(year, month, day, now);
  return age >= MIN_AGE_YEARS;
}

export function birthDateToIso(value: string): string {
  if (!isValidBirthDate(value)) return '';
  const parsed = parseDdMmYyyy(value)!;
  const { day, month, year } = parsed;
  return new Date(Date.UTC(year, month - 1, day)).toISOString();
}
